import React from 'react';
import styles from './Placeholder.module.scss';

const PlaceHolderFacets = () => {
    return (
        <ul className="op-selection">
            <li className={styles.loading_simulator_facets}>
            </li>
        </ul>
    );
};

export default PlaceHolderFacets;
